import { axiosObject } from "../config";

export default function verifyRegistration(form: any) {
  let payload = {
    type: "email",
    value: form.value.email,
    token: form.value.token,
    after_verification: "respond_with_token"
  };

  return new Promise((resolve, reject) => {
    let uri = "access/verify-registration";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          // have to handle error, coming only 1st word
          form.setErrors({ token: errors.response.data.message });
          reject(errors.response.data.message);
        }
        reject(errors);
      });
  });
}
